<template>
    <v-switch
        v-model="defaultForBlock"
        :disabled="defaultForBlock === true"
        :loading="loading"
        @change="setPackageDefault"
    ></v-switch>
</template>

<script>
export default {
    name: "PackageDefaultSwitch",
    props: {
        pkg: Object
    },
    data() {
        return {
            defaultForBlock: null,
            loading: false,
        }
    },
    methods: {
        setPackageDefault: function () {
            this.loading = true;

            apiAxios.post('packages/'+this.pkg.PackageID+'/default_for_block')
                .then((response) => {
                    if(response.status === 200) {
                        this.$store.commit(
                            "showSnackbarSuccess",
                            'Zmieniono domyślny komplet.'
                        );
                        this.$emit('defaultPackageSet');
                    } else {
                        this.defaultForBlock = !this.defaultForBlock;
                        this.$store.commit(
                            "showSnackbarError",
                            'Nie udało się zmienić domyślnego kompletu.'
                        );
                    }
                })
                .catch(() => {
                    this.defaultForBlock = !this.defaultForBlock;
                })
                .then(() => {
                    this.loading = false;
                });
        },
    },
    created() {
        this.defaultForBlock = this.pkg.DefaultForBlock;
    }
}
</script>
